import request from '@/utils/request'


export const otherList = (data) => request.post('/apis/api/friend/index', data);  //成员列表

export const otherInfo = (data) => request.post('/apis/api/friend/getinfo', data);  //成员详情

export const otherAdd = (data) => request.post('/apis/api/friend/addPost', data);  //添加成员

export const otherEdit = (data) => request.post('/apis/api/friend/editPost', data);  //编辑成员

export const otherDelete = (data) => request.post('/apis/api/friend/del', data);  //删除成员
